"use client";
import { fork, scopeBind } from "effector";
import { Provider } from "effector-react";
import { TooltipProvider } from "@components/organisms/assistant/ui/tooltip";
import React, { useEffect } from "react";
import { attachLogger } from "effector-logger";
import { usePathname, useRouter } from "next/navigation";
import { routerInit } from "@features/shared/router";
import { appMounted, routePathNameChanged } from "@features/app/model";
import { AnalyticsService } from "@features/shared/analytics";

const scope = fork();
/*attachLogger({ scope });

if (typeof window !== "undefined") {
    window.scope = scope;
}*/
export function Providers({ children }: { children: React.ReactNode }) {
    const router = useRouter();
    const pathname = usePathname();

    scopeBind(routerInit, { scope })(router);

    useEffect(() => {
        scopeBind(appMounted, { scope })();
    }, []);

    useEffect(() => {
        const fn = scopeBind(routePathNameChanged, { scope });
        fn(pathname);
    }, [pathname]);

    useEffect(() => {
        AnalyticsService.init();
    }, []);

    return (
        <Provider value={scope}>
            <TooltipProvider>{children}</TooltipProvider>
        </Provider>
    );
}
